// src/components/SolutionsPage.js
import React from 'react';
import { Link } from 'react-router-dom';

function SolutionsPage() {
  return (
    <main className="container py-5 px-2" style={{ maxWidth: 900 }}>
      {/* Main Heading */}
      <header className="text-center mb-5">
        <h1
          style={{
            color: 'var(--color-pink)',
            fontSize: '2.3rem',
            fontWeight: 700,
            marginBottom: '0.8rem',
            lineHeight: 1.2,
          }}
        >
          AI Solutions for Sport, Rehab & Insurance
        </h1>
        <p
          style={{
            maxWidth: 580,
            margin: '0 auto',
            color: '#ccc',
            fontSize: '1.08rem',
            letterSpacing: '.01em',
          }}
        >
          Real-time insights for teams, trainers, clinics, and insurance partners. Optimize performance, reduce injuries, and prove outcomes—no matter your role.
        </p>
      </header>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
        {/* Sports Teams */}
        <SectionCard
          title="Sports Teams"
          colorVar="var(--color-neon)"
          bgGradient="linear-gradient(135deg, #f6d365 0%, #fda085 100%)"
          bullets={[
            "Live analytics for coaches and staff",
            "Spot injury risks before they happen",
            "Motivate and monitor every player"
          ]}
          description="Unify your squad. AI-driven data keeps your team performing and healthy all season."
          cta="Book a Demo"
        />

        {/* Trainers */}
        <SectionCard
          title="Personal Trainers"
          colorVar="var(--color-purple)"
          bgGradient="linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)"
          bullets={[
            "Instant feedback & form correction",
            "Clear progress tracking for every client",
            "More results, higher retention"
          ]}
          description="Deliver world-class coaching with data-driven progress, accountability, and results."
          cta="Try It For Free"
        />

        {/* Clinics */}
        <SectionCard
          title="Clinics & Physio"
          colorVar="var(--color-green)"
          bgGradient="linear-gradient(135deg, #fccb90 0%, #d57eeb 100%)"
          bullets={[
            "Structured, personalized rehab plans",
            "Automated compliance and session reports",
            "Better patient outcomes, less admin"
          ]}
          description="Accelerate recovery and prove clinical value with real-time AI and paperless reporting."
          cta="Request a Pilot"
        />

        {/* Insurance */}
        <SectionCard
          title="Insurers"
          colorVar="var(--color-teal)"
          bgGradient="linear-gradient(135deg, #7fd1b9 0%, #24c6dc 100%)"
          bullets={[
            "First real-time, objective data on every player",
            "No more questionnaires or unreliable self-reporting",
            "Reduce false claims & fraud with trusted AI validation",
            "Enable 'Pay as You Train'—dynamic policy options"
          ]}
          description="Go beyond paperwork. Instantly access verified movement and recovery data, detect risk early, cut fraud, and unlock next-generation insurance products."
          cta="Contact Us"
        />
      </div>

      {/* CTA */}
      <section className="text-center mt-5" style={{ color: '#ccc' }}>
        <p style={{ fontSize: '1.11rem', fontWeight: 500 }}>
          Looking for a custom solution?
          {' '}
          <Link
            to="/contact"
            className="text-decoration-none"
            style={{
              color: 'var(--color-teal)',
              fontWeight: 700,
            }}
          >
            Let’s talk
          </Link>
          .
        </p>
      </section>
    </main>
  );
}

// Reusable card component for each solution section
function SectionCard({ title, colorVar, bgGradient, bullets, description, cta }) {
  return (
    <section
      className="glass text-center p-4"
      style={{
        borderRadius: '20px',
        background: bgGradient,
        color: '#222',
        boxShadow: '0 6px 24px 0 rgba(0,0,0,0.06)',
        margin: 0,
        minHeight: 285,
      }}
    >
      <h2
        style={{
          color: colorVar,
          fontWeight: 700,
          fontSize: '1.28rem',
          marginBottom: '0.6rem',
          letterSpacing: '.01em',
        }}
      >
        {title}
      </h2>
      <p style={{ marginBottom: '1rem', color: '#222', fontSize: '1rem', minHeight: 44 }}>
        {description}
      </p>
      <ul
        style={{
          textAlign: 'left',
          margin: '0 auto 1.1rem',
          padding: 0,
          maxWidth: 320,
          fontSize: '.98rem',
          listStyle: 'none',
        }}
      >
        {bullets.map((b, i) => (
          <li key={i} style={{ margin: '0 0 0.4rem 0', paddingLeft: 24, position: 'relative' }}>
            <span
              style={{
                display: 'inline-block',
                position: 'absolute',
                left: 0,
                top: 2,
                fontWeight: 700,
                color: colorVar,
                fontSize: '1.2em',
              }}
            >
              •
            </span>
            {b}
          </li>
        ))}
      </ul>
      <Link
        to="/contact"
        className="btn btn-secondary"
        style={{
          padding: '0.72rem 1.4rem',
          backgroundColor: colorVar,
          border: 'none',
          borderRadius: '8px',
          color: '#fff',
          fontWeight: 600,
          fontSize: '1rem',
          textDecoration: 'none',
          marginTop: '0.5rem',
          display: 'inline-block',
        }}
      >
        {cta}
      </Link>
    </section>
  );
}

export default SolutionsPage;
